import React from "react";
import {useStyles} from "./DragScreen.style.js";
export default function DragScreen({ dragScreen }) {
  const classes = useStyles();
  return dragScreen ? <div className={classes.dragScreen}>Drop Here</div> : "";
}
